import { ACCUMULATION_MET_STATUS_VALUES } from './uiConstants';

export const userHasMetOutOfPocketMax = (value: string): boolean =>
  value === ACCUMULATION_MET_STATUS_VALUES.OUT_OF_POCKET_MET;

export const userHasMetDeductible = (value: string): boolean =>
  value === ACCUMULATION_MET_STATUS_VALUES.OUT_OF_POCKET_MET ||
  value === ACCUMULATION_MET_STATUS_VALUES.DEDUCTIBLE_MET;
